var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 140,
    viewBox: "0 0 143 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 130.312H139.812",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 129.375V97.875C13.875 97.3227 14.3227 96.875 14.875 96.875H30.6875C31.2398 96.875 31.6875 97.3227 31.6875 97.875V129.375",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0625 129.062V80.0625C46.0625 79.5102 46.5102 79.0625 47.0625 79.0625H63.1875C63.7398 79.0625 64.1875 79.5102 64.1875 80.0625V129.062",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5625 129.062V61.9375C78.5625 61.3852 79.0102 60.9375 79.5625 60.9375H95.6875C96.2398 60.9375 96.6875 61.3852 96.6875 61.9375V129.062",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.062 129.062V45.6875C111.062 45.1352 111.51 44.6875 112.063 44.6875H128.187C128.74 44.6875 129.188 45.1352 129.188 45.6875V129.062",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 81.5625C40.125 71.25 104.188 40.625 129.812 10.3125",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.875 12.5C114.562 12.5 123.338 11.1023 128.732 10.2268C129.413 10.1162 129.997 10.7127 129.874 11.392L127.312 25.625",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.752a224f5dc51446d6fb781447f65f2c.svg";
export { ForwardRef as ReactComponent };